import { makeStyles } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getOrderAndSalaryDetail, getUSOrderAndSalaryDetaill, getUSOrderAndSalaryDetailPublic } from '../../../actions/driverMobileActions';
import { getOrdersByDate, getTeamOrdersByDate } from '../../../actions/driverMobileActionsCA';
import { getIsTeamData } from '../../../utilities/common';
import { normalizeDriverIdParam } from '../../../utilities/driverMobileDirectEntry';
import FullscreenLoading from '../../FullscreenLoading';
import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme)=> ({
    root: {
        width: 313,
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    item: {
        color: '#101820',
        fontSize: 18,
        fontWeight: 'bold',
        letterSpacing: 0,
        marginTop: 18,
        paddingBottom: 6,
        width: 290,
        borderBottom: '2px solid #0D1923'
    },
    itemClicked: {
        borderRadius: 4,
        backgroundColor: 'rgba(235,236,239,0.8)',
        paddingLeft: 13.5,
        paddingTop: 8,
        paddingBottom: 10,
        paddingRight: 12
    },
    itemDateClicked: {
        color: '#F68D2E',
        fontSize: 18,
        letterSpacing: 0,
        paddingBottom: 7,
        borderBottom: '1.5px solid #F68D2E'
    },
    itemContentClicked: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 10,
        paddingBottom: 5
    }
}))

const AccordionStyled = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: 'none',
    '&:before': {
        display: 'none',
    }
}));
const MuiAccordionStyled = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    '& .MuiAccordionSummary-root': {
        minHeight: '25px !important',
        maxHeight: '25px !important'
    },
    border: 'none',
    '&:before': {
        display: 'none',
    }
}));
const AccordionSummaryStyled = styled((props) => (
    <MuiAccordionSummary {...props}/>
))(({ theme }) => ({
    border: 'none',
    // flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(180deg)'
    },
    color: '#101820',
    fontSize: 18,
    fontWeight: 'bold',
    letterSpacing: 0,
    marginTop: 18,
    paddingBottom: 6,
    width: 290,
    borderBottom: '2px solid #0D1923',
    padding: '0px !important'
}));
const MuiAccordionSummaryStyled = styled((props) => (
    <MuiAccordionSummary {...props}/>
))(({ theme }) => ({
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(180deg)'
    },
    '& .MuiAccordionSummary-content': {
        margin: '0 !important'
    },
    padding: 0,
    backgroundColor: '#eff0f2'
}));
const AccordionDetailsStyled = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
    border: 'none',
    paddingLeft: '0px !important'
}));
const MuiAccordionDetailsStyled = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
    border: 'none',
    backgroundColor: '#eff0f2',
    padding: 0
}));


function IncomeDeliveryStatements(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation('incomeOverview');
    const { driverId: rawDriverId } = useParams();
    const directEntryDriverId = normalizeDriverIdParam(rawDriverId);

    const [loading, setLoading] = useState(false);
    const [salaryList, setSalaryList] = useState([]);

    function transferMilage(meters) {
        return parseFloat(meters * 0.000621371192).toFixed(2);
    }

    function formatDate(dateString) {
        if (!dateString || dateString.length !== 8) return dateString;
        const year = dateString.substring(0, 4);
        const month = dateString.substring(4, 6);
        const day = dateString.substring(6, 8);
        return `${year}-${month}-${day}`;
    }

    useEffect(() => {
        if(props.startTime && props.endTime) {
            // In direct-entry mode only the public (unauthenticated) endpoint is
            // safe to call. Non-numeric params (e.g. "demo") skip the fetch so the
            // authenticated-endpoint interceptor can never fire and reload the page.
            if (rawDriverId) {
                if (!directEntryDriverId) return;
                const from = formatDate(props.startTime);
                const to   = formatDate(props.endTime);
                setLoading(true);
                dispatch(getUSOrderAndSalaryDetailPublic(directEntryDriverId, from, to))
                    .then((res) => { setLoading(false); setSalaryList(res); })
                    .catch(() => setLoading(false));
                return;
            }

            setLoading(true);
            // Canada: use CA endpoints (YYYYMMDD, no date reformatting)
            if (import.meta.env.VITE_COUNTRY === 'CA') {
                const isTeamData = getIsTeamData();
                const getFunc = isTeamData ? getTeamOrdersByDate : getOrdersByDate;
                dispatch(getFunc(props.startTime, props.endTime))
                .then((res) => {
                    setLoading(false);
                    setSalaryList(res);
                })
                .catch(() => setLoading(false));
                return;
            }
            // US authenticated flow: reformat dates and pick endpoint by region
            const formattedStartTime = formatDate(props.startTime);
            const formattedEndTime = formatDate(props.endTime);
            let getOrderAndSalaryDetailFun = import.meta.env.VITE_COUNTRY === 'US' ? getUSOrderAndSalaryDetaill : getOrderAndSalaryDetail;
            dispatch(getOrderAndSalaryDetailFun(formattedStartTime, formattedEndTime))
            .then((res) => {
                setLoading(false);
                setSalaryList(res);
            })
            .catch(() => setLoading(false));
        }
    }, [props.startTime, props.endTime, rawDriverId, directEntryDriverId])

    return (
        <div className={classes.root}>
            {
                salaryList?.length > 0 &&
                salaryList.map((salary, index) => {
                    return (
                        <AccordionStyled key={salary.date || index}>
                            <AccordionSummaryStyled
                                expandIcon={<ArrowDropDownIcon />}
                            >
                            <div>{salary.date}</div>
                            </AccordionSummaryStyled>
                            <AccordionDetailsStyled>
                                {import.meta.env.VITE_COUNTRY === 'CA' ? (
                                    // Canada fields
                                    <div className={classes.itemClicked}>
                                        <div className={classes.itemContentClicked} style={{borderBottom: '1px solid #8A8B8A'}}>
                                            <div>{t('daily_new')}</div>
                                            <div>{salary.new}</div>
                                        </div>
                                        <div className={classes.itemContentClicked} style={{borderBottom: '1px solid #8A8B8A'}}>
                                            <div>{t('daily_completed')}</div>
                                            <div>{salary.completed}</div>
                                        </div>
                                    </div>
                                ) : (
                                    // US fields (original)
                                    <div className={classes.itemClicked}>
                                        <div className={classes.itemContentClicked} style={{borderBottom: '1px solid #8A8B8A'}}>
                                            <div>{t('daily_new')}</div>
                                            <div>{salary.new_order_count}</div>
                                        </div>
                                        <div className={classes.itemContentClicked} style={{borderBottom: '1px solid #8A8B8A'}}>
                                            <div>{t('daily_completed')}</div>
                                            <div>{salary.total_order_count}</div>
                                        </div>
                                        <div style={{fontSize: '12px', color: '#d48806', marginTop: 10, background: '#fffbe6', padding: 3, borderRadius: 5}}>
                                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                                <div>Same Address Order - First Order</div>
                                                <div>{salary.first_address_order_count}</div>
                                            </div>
                                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                                <div>Same Address Order - Non-First Order</div>
                                                <div>{salary.rest_address_order_count}</div>
                                            </div>
                                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                                <div>Non-Same Address Order</div>
                                                <div>{salary.non_address_order_count}</div>
                                            </div>
                                        </div>
                                        {
                                            import.meta.env.VITE_COUNTRY === 'US' &&
                                            salary?.milist?.length > 0 &&
                                            salary.milist.map((mi, i) => (
                                                <div className={classes.itemContentClicked} style={{borderBottom: '1px solid #8A8B8A'}}>
                                                    <MuiAccordionStyled>
                                                        <MuiAccordionSummaryStyled
                                                            expandIcon={<ExpandMoreIcon />}
                                                        >
                                                        <div>{mi.route_name}</div>
                                                        </MuiAccordionSummaryStyled>
                                                        <MuiAccordionDetailsStyled>
                                                            <div className={classes.itemClicked}>
                                                            <div className={classes.itemContentClicked} style={{borderBottom: '1px solid #8A8B8A'}}>
                                                                <div>{t('driving_distance')}</div>
                                                                <div>{transferMilage(mi.driving_distance)}</div>
                                                            </div>
                                                            <div className={classes.itemContentClicked}>
                                                                <div>{t('total_count')}</div>
                                                                <div>{mi.total_count}</div>
                                                            </div>
                                                            </div>
                                                        </MuiAccordionDetailsStyled>
                                                    </MuiAccordionStyled>
                                                </div>
                                            ))
                                        }
                                    </div>
                                )}
                            </AccordionDetailsStyled>
                        </AccordionStyled>
                    )
                })
            }
            <FullscreenLoading open={loading}/>
        </div>
    )
}
export default IncomeDeliveryStatements;
